'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../DataDisplays/Avatar/Avatar.js');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');
var Calendar_utils = require('./Calendar.utils.js');
var Calendar_constants = require('./Calendar.constants.js');

const WeekHeader = ()=>{
    const weekdays = Array.from(Calendar_constants.dayMap.values());
    return jsxRuntime.jsx(Box, {
        className: "grid w-full grid-cols-7 place-items-center gap-1",
        children: weekdays.map((item)=>jsxRuntime.jsx(Box, {
                className: "flex h-5 items-center justify-center",
                children: jsxRuntime.jsx(Typography, {
                    variant: "body3",
                    className: "leading-normal text-w-gray-500",
                    children: item
                })
            }, item))
    });
};
const SelectHeader = ({ visibleDate, onChange })=>{
    const isFirstMonth = (visibleDate === null || visibleDate === void 0 ? void 0 : visibleDate.month) === 1;
    const isLastMonth = (visibleDate === null || visibleDate === void 0 ? void 0 : visibleDate.month) === 12;
    const onChangeToPrevMonth = ()=>{
        isFirstMonth ? onChange === null || onChange === void 0 ? void 0 : onChange({
            year: visibleDate.year - 1,
            month: 12,
            date: 1
        }) : onChange === null || onChange === void 0 ? void 0 : onChange({
            year: visibleDate.year,
            month: visibleDate.month - 1,
            date: 1
        });
    };
    const onChangeToNextMonth = ()=>{
        isLastMonth ? onChange === null || onChange === void 0 ? void 0 : onChange({
            year: visibleDate.year + 1,
            month: 1,
            date: 1
        }) : onChange === null || onChange === void 0 ? void 0 : onChange({
            year: visibleDate.year,
            month: visibleDate.month + 1,
            date: 1
        });
    };
    const { year, month } = visibleDate && Calendar_utils.getKoreanTimeString(visibleDate);
    return jsxRuntime.jsxs(Box, {
        className: "flex h-[50px] w-full gap-4",
        children: [
            jsxRuntime.jsx(Box, {
                "data-testid": "design-system-calendar--to-prev-month",
                className: "size-6 cursor-pointer text-gray-600",
                onClick: onChangeToPrevMonth,
                children: jsxRuntime.jsx(SystemIcon, {
                    name: "large_arrow_left",
                    className: "text-gray-600"
                })
            }),
            jsxRuntime.jsxs(Typography, {
                variant: "subTitle2",
                className: "h-fit w-full text-center leading-normal text-gray-900",
                children: [
                    year,
                    " ",
                    month
                ]
            }),
            jsxRuntime.jsx(Box, {
                "data-testid": "design-system-calendar--to-next-month",
                className: "size-6 cursor-pointer text-gray-600",
                onClick: onChangeToNextMonth,
                children: jsxRuntime.jsx(SystemIcon, {
                    name: "large_arrow_right",
                    className: "text-gray-600"
                })
            })
        ]
    });
};
const DateBox = ({ selected, date, disabled = false, onChange })=>{
    const organizedDate = String(date === null || date === void 0 ? void 0 : date.date).length === 1 ? `0${date === null || date === void 0 ? void 0 : date.date}` : date === null || date === void 0 ? void 0 : date.date;
    const onChangeDate = ()=>{
        if (disabled) return;
        onChange === null || onChange === void 0 ? void 0 : onChange(date);
    };
    return jsxRuntime.jsx(Box, {
        className: tailwindMerge.twMerge('flex size-[42px] cursor-pointer items-center justify-center rounded-full bg-w-white p-2 text-center', !disabled && !selected && 'hover:bg-primary-10', selected && 'bg-primary', disabled && 'cursor-default'),
        onClick: onChangeDate,
        children: jsxRuntime.jsx(Typography, {
            variant: "body1",
            className: tailwindMerge.twMerge('text-w-gray-900', selected && 'text-w-white', disabled && 'text-w-gray-300'),
            children: organizedDate
        })
    });
};

exports.DateBox = DateBox;
exports.SelectHeader = SelectHeader;
exports.WeekHeader = WeekHeader;
